<template>
  <div>
    <v-container>
      <div>
        <v-layout>
          <v-flex xs12 sm6>
            <Multiselect
              @input="onFilterCampaign"
              :placeholder="$t('All')"
              v-model="filter.campaign"
              :options="campaignOption"
              :allow-empty="true"
              label="name"
            ></Multiselect>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn @click="showAdvancedSearch" outline color="primary">Advanced Search </v-btn>
            <exportxlsx
              :promisedValue="getXlsxData"
              :filename="'Followup_Message_Report'"
            ></exportxlsx>
          </v-flex>
        </v-layout>
      </div>
      <div class="mt-3">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.start_date | dateFormat('DD/MM/YYYY') }}</td>
              <td>{{ props.item.end_date | dateFormat('DD/MM/YYYY') }}</td>
              <td>{{ props.item.messages }}</td>
              <td>{{ props.item.total_codes }}</td>
              <td>{{ props.item.total_codes_used }}</td>
              <td>{{ props.item.total_codes_available }}</td>
              <td>
                <v-btn icon ripple @click="onViewCode(props.item)">
                  <v-icon>search</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>

    <!-- Search Dialog -->
    <v-dialog v-model="searchDialog" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="searchDialog = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Name') }}</label>
                <input v-model="filter.name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Code') }}</label>
                <input v-model="filter.code" class="form-control" type="text" />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="codeDialog" width="800px" persistent>
      <ReportCodeDialog
        v-if="codeDialog"
        :selectedCampaign="selectedCampaign"
        @close="closeCodeDialog"
      ></ReportCodeDialog>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import Multiselect from 'vue-multiselect'
import ReportCodeDialog from './ReportCodeDialog.vue'
import moment from 'moment'

export default {
  components: {
    exportxlsx,
    Multiselect,
    ReportCodeDialog
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'Campaign Name', value: 'name', sortable: false },
        { text: 'Start Date', value: 'start_date', sortable: false },
        { text: 'End Date', value: 'end_date', sortable: false },
        { text: 'Message', value: 'messages', sortable: false },
        { text: 'จำนวน Code ทั้งหมด', value: 'total_codes', sortable: false },
        { text: 'จำนวน Code ที่ส่งไปแล้ว', value: 'total_codes_used', sortable: false },
        { text: 'จำนวน Code ที่เหลือ', value: 'total_codes_available', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      searchDialog: false,
      filter: {
        name: '',
        code: '',
        campaign: ''
      },
      campaignOption: [],
      codeDialog: false,
      selectedCampaign: null
    }
  },
  mounted() {
    this.getCampaigns()
    this.getData()
  },
  methods: {
    showAdvancedSearch() {
      this.searchDialog = true
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    onsearch() {
      this.searchDialog = false
      this.getData()
    },
    clearsearch() {
      this.searchDialog = false
      this.filter = {
        name: '',
        code: ''
      }
      this.getData()
    },
    async getCampaigns() {
      let request = {
        pageid: this.selectedBot.pageid
      }
      let response = await api.getFollowMessageCampaigns(request)

      if (response.status == true) {
        this.campaignOption = response.result
      } else return []
    },
    async getData() {
      return new Promise(async (resolve) => {
        let request = {
          pageid: this.selectedBot.pageid,
          params: {
            limit: this.limit,
            offset: this.offset
          }
        }

        if (this.filter.campaign) {
          Object.assign(request.params, { campaign_id: this.filter.campaign.id })
        }
        if (this.filter.name) {
          Object.assign(request.params, { name: this.filter.name })
        }
        if (this.filter.code) {
          Object.assign(request.params, { code: this.filter.code })
        }

        this.loading = true

        let response = await api.getFollowupMessageReport(request)

        if (response.status == true) {
          this.items = response.data
          this.total = response.total
          this.loading = false
          resolve(response.data)
        } else return []
      })
    },
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.limit = this.total
        var data = await this.getData()

        resolve(
          data.map((el) => {
            return {
              'Campaign Name': el.name,
              'Start Date': el.start_date ? moment(el.start_date).format('DD/MM/YYYY') : '-',
              'End Date': el.end_date ? moment(el.end_date).format('DD/MM/YYYY') : '-',
              Message: el.messages,
              'จำนวน Code ทั้งหมด': el.total_codes,
              'จำนวน Code ที่ส่งไปแล้ว': el.total_codes_used,
              'จำนวน Code ที่เหลือ': el.total_codes_available
            }
          })
        )

        this.limit = 10
        this.getData()
      })
    },
    onFilterCampaign(campaign) {
      if (campaign) {
        this.filter.campaign = campaign
      } else {
        this.filter.campaign = ''
      }

      this.getData()
    },
    onViewCode(campaign) {
      this.selectedCampaign = campaign
      this.codeDialog = true
    },
    closeCodeDialog() {
      this.selectedCampaign = null
      this.codeDialog = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/FollowupMessageReport.vue